import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { isDevOnlyFeatureEnabled } from '../utils/env';

const COLLAPSE_KEY = 'sa-sidebar-collapsed';

export default function Sidebar() {
  const { signOut } = useAuth();
  const { showConfirm } = useToast();
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(COLLAPSE_KEY) === '1',
  );

  const handleSignOut = async () => {
    const confirmed = await showConfirm(
      'Apakah Anda yakin ingin keluar dari akun ini?',
      'Sign out',
      'danger',
    );
    if (confirmed) signOut();
  };

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem(COLLAPSE_KEY, next ? '1' : '0');
      return next;
    });
  };

  const navLinkClass = ({ isActive }) =>
    `sidebar-link nav-link d-flex align-items-center gap-2 rounded-3 ${
      collapsed ? 'justify-content-center px-2' : ''
    } ${isActive ? 'active bg-primary text-white' : 'text-white text-opacity-75'}`;

  const navItems = [
    { to: '/dashboard', end: true, icon: 'bi-house-door-fill', label: 'Dashboard' },
    { to: '/program', icon: 'bi-layers-fill', label: 'Program' },
    { to: '/batch', icon: 'bi-bar-chart-fill', label: 'Batch' },
    { to: '/employee', end: true, icon: 'bi-people-fill', label: 'Employee' },
    ...(isDevOnlyFeatureEnabled()
      ? [{ to: '/employee/my-progress', icon: 'bi-speedometer2', label: 'My Progress' }]
      : []),
    { to: '/division', icon: 'bi-diagram-3-fill', label: 'Division' },
    { to: '/roles', icon: 'bi-shield-lock-fill', label: 'Roles & Access' },
    { to: '/executive-api', icon: 'bi-key-fill', label: 'API Key' },
  ];

  return (
    <aside
      className="d-flex flex-column flex-shrink-0 p-3 text-bg-dark position-relative"
      style={{
        width: collapsed ? '76px' : '240px',
        transition: 'width 0.2s ease',
      }}
    >
      <button
        type="button"
        className="btn btn-sm btn-dark border border-secondary rounded-circle position-absolute d-flex align-items-center justify-content-center"
        style={{ width: '28px', height: '28px', top: '18px', right: '-14px', zIndex: 10 }}
        onClick={toggleCollapsed}
        title={collapsed ? 'Perluas sidebar' : 'Ciutkan sidebar'}
      >
        <i className={`bi ${collapsed ? 'bi-chevron-right' : 'bi-chevron-left'} small`}></i>
      </button>

      <div
        className={`d-flex align-items-center mb-3 text-white text-decoration-none ${
          collapsed ? 'justify-content-center' : ''
        }`}
      >
        <i className="bi bi-grid-fill me-2"></i>
        {!collapsed && <span className="fs-5 fw-semibold">ILS-SA</span>}
      </div>
      <hr className="border-secondary" />

      <ul className="nav nav-pills flex-column mb-auto">
        {navItems.map((item) => (
          <li className="nav-item" key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={navLinkClass}
              title={collapsed ? item.label : undefined}
            >
              <i className={`bi ${item.icon}`}></i>
              {!collapsed && item.label}
            </NavLink>
          </li>
        ))}
      </ul>

      <hr className="border-secondary" />

      <ul className="nav flex-column mt-auto">
        <li>
          <NavLink
            to="/settings"
            className={navLinkClass}
            title={collapsed ? 'Settings' : undefined}
          >
            <i className="bi bi-gear-fill"></i>
            {!collapsed && 'Settings'}
          </NavLink>
        </li>
        <li>
          <button
            type="button"
            className={`sidebar-link nav-link d-flex align-items-center gap-2 rounded-3 text-white text-opacity-75 w-100 border-0 bg-transparent text-start ${
              collapsed ? 'justify-content-center px-2' : ''
            }`}
            onClick={handleSignOut}
            title={collapsed ? 'Sign out' : undefined}
          >
            <i className="bi bi-door-closed-fill"></i>
            {!collapsed && 'Sign out'}
          </button>
        </li>
      </ul>

      <style>{`
        .sidebar-link {
          transition: background-color 0.15s ease, opacity 0.15s ease, color 0.15s ease;
          opacity: 0.85;
          font: inherit;
          line-height: inherit;
        }
        .sidebar-link i {
          transition: opacity 0.15s ease;
          font-size: 1rem;
        }
        .sidebar-link:hover {
          background-color: rgba(255, 255, 255, 0.1);
          color: #fff !important;
          opacity: 1;
        }
        .sidebar-link.active {
          opacity: 1;
        }
      `}</style>
    </aside>
  );
}
